import React from "react";
import cx from "classnames";
import styles from "./WellbeingCentre.module.scss";
import Image from "@components/Image";
import Link from "@components/Link";
import Icons from "@gstyles/styleguide/icons";
import Button from "@components/Button";
import _ from "lodash";
interface Props {
  data: {
    image: {
      src: string;
      alt: string;
      placement?: string;
    };
    title: string;
    time: string;
    content: string;
    button?: {
      label: string;
      href?: string;
    };
  };
}

export default function SubItem({ data }: Props) {
  return (
    <div
      className={cx(
        styles.subItem,
        data.image?.placement === "right" ? "flex-row-reverse" : ""
      )}
    >
      <Image
        wrapperProps={{ className: cx(styles.image) }}
        src={data?.image?.src}
        alt={data?.image?.alt}
        layout="fill"
        objectFit="cover"
      />
      <div className={cx(styles.infoSection)}>
        <div className="flex items-center justify-between">
          <div className={cx(styles.title)}>{data.title}</div>
          <div className={cx(styles.time)}>
            <Icons
              name="clock-outline"
              className={cx(styles.icon)}
              color="#af915e"
            />
            <div className={cx(styles.value)}>{data.time}</div>
          </div>
        </div>
        <div className={cx(styles.content)}>{data.content}</div>
        <Link href={_.get(data, "button.href") || "#"}>
          <Button
            type="icon"
            suffix="shape-arrow"
            className={cx(styles.enquireBtn)}
            label={_.get(data, "button.label")}
            // label={i18n.t("Button.makeAnEnquire")}
            // onClick={() => router.push("contact")}
          />
        </Link>
      </div>
    </div>
  );
}
